import { Checkbox } from 'components/ui';
import type { FirmDocumentsSelectionCheckboxProps } from './FirmDocumentsSelectionCheckbox.props';

const FirmDocumentsSelectionCheckbox = (props: FirmDocumentsSelectionCheckboxProps) => (
  <Checkbox visualVariant="selection" {...props} />
);

export default FirmDocumentsSelectionCheckbox;
